import React from 'react';

import * as Antd from 'antd';


export const UserRoleForm = props => {
    const [form] = Antd.Form.useForm();

    const layout = {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
    };

    const tailLayout = {
        wrapperCol: { span: 18, offset: 6 },
    };

    return (
        <Antd.Form
            {...layout}
            form={form}
            initialValues={props.initialValues}
            onFinish={values => {
                if (props.onSuccess) {
                    props.onSuccess(values);
                }
            }}
            onFinishFailed={(err) => {
                console.log(err);
            }}
        >
            {props.initialValues && props.initialValues.id
                ? <Antd.Form.Item name="id" label="ID">
                    <Antd.Input disabled={true} />
                </Antd.Form.Item>
                : null}
            <Antd.Form.Item
                name="code"
                label="Code"
                rules={[{ required: true }]}
            >
                <Antd.Input />
            </Antd.Form.Item>
            <Antd.Form.Item
                name="name"
                label="Name"
                rules={[{ required: true }]}
            >
                <Antd.Input />
            </Antd.Form.Item>            

            <Antd.Form.Item
                {...tailLayout}
                style={{
                    marginTop: 10
                }}
            >
                <Antd.Button
                    type="primary"
                    htmlType="submit"
                >
                    Submit
                </Antd.Button>
            </Antd.Form.Item>
        </Antd.Form >
    );
}